module.exports = __webpack_public_path__ + "static/img/calendar.e9b8ab01.svg";